export const API_VERSION = "2006-03-01";
export const BUCKET_NAME = "datasalesio-imagens";
export const BUCKET_REGION = "us-east-1";
export const IDENTITY_POOL_ID =
  "us-east-1:5876d72e-99c7-4a3d-a6e8-1a4da44e4835";
export const URI_BUCKET = "https://datasalesio-imagens.s3.amazonaws.com/";
